module.exports = __webpack_public_path__ + "img/down-notes.d97d34d5.png";